import React from 'react';
import {FieldArray} from 'formik';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../../res/translations/messages';
import GeneratorClassifier2ChoiceType from '../GeneratorClassifier2ChoiceType';
import CommonFields from './CommonFields';

// TODO remove disable lint
/* eslint-disable react/jsx-no-bind */
const GeneratorClassifier2Type = ({name, form, currPage, previousPages}) => {
    const parameters = form.values.parameters || [];
    const extraFields = form.values.extraFields || [];
    const renderChoice = (props) => {
        return <GeneratorClassifier2ChoiceType id={`${name}.choicesScripts`} currPage={currPage}
            parameters={parameters} extraFields={extraFields} {...props} />;
    };

    return (
        <>
            <CommonFields name={name} form={form} showSubtitle={false} previousPages={previousPages} />
            <div className="form-group">
                <h4>
                    &gt; <FormattedMessage {...messages.surveys.form.label.optionList} />
                </h4>
                <FieldArray name={`${name}.choices`} render={renderChoice} />
            </div>
        </>
    );
};

export default GeneratorClassifier2Type;
